<template>
  <div class="contents" :cn="componentName">
    <label v-bind:class="cssLabel">
      <slot name="label"></slot>
    </label>

    <input
    :max="max"
    :min="min"
      :ref="setref"
      :type="type"
      :value="value"
      :placeholder="options !== undefined && options.placeholder !== undefinded ? options.placeholder : placeholder"
      :required="required"
      :disabled="disabled"
      :class="cssInput"
      :tabindex="tabindex"
      @input="$emit('update:value', $event.target.value);$emit('update:input', $event)"
      @keyup.enter="
        $emit('text-input:moveon', value);
        $emit('text-input:enter', value);
      "
      @keyup.tab="
        $emit('text-input:moveon', value);
        $emit('text-input:tab', value);
      "
    />
  </div>
</template>

<script>
export default {
  props: {
    max: {
    },
    min: {},

    value: [String, Number],
    predefinedStyle: String,
    placeholder: String,
    type: {
      type: String,
      default: "text",
    },
    required: {
      type: [String, Boolean],
      default: false,
    },
    disabled: {
      type: [String, Boolean],
      default: false,
    },
    additionalCss: [String],
    setref: {
      type: String,
    },
    options:{},
    tabindex :{
        type: String,
        default : "0",
    }
  },
  data() {
    return {
    };
  },
  computed: {
    predefinedStyles(){
        return {
        default: {
          label:
            "text-base text-stone-900 dark:text-slate-100 font-bold mb-1 block",
          input: {
            "w-full": true,
            "text-base": true,
            "outline-none": true,
            "border-2": true,
            "border-gray-200": true,
            "dark:border-transparent": true,
            "dark:hover:border-slate-500": true,
            "dark:focus-visible:border-slate-500": true,
            "focus-visible:border-accent-color": true,
            "rounded-md": true,
            "py-1": true,
            "px-3": true,
            "dark:bg-gray-700": !this.disabled,
            "dark:bg-gray-900": this.disabled,
            "bg-neutral-100": this.disabled,
            "cursor-not-allowed" : this.disabled,
          },
        },
        invoice: {
          label: "text-base text-stone-900 dark:text-slate-100 font-bold mb-1",
          input: {
            "w-full": true,
            "text-base": true,
            "outline-none": true,
            "border-2": true,
            "border-gray-200": true,
            "dark:border-transparent": true,
            "dark:hover:border-slate-500": true,
            "dark:focus-visible:border-slate-500": true,
            "focus-visible:border-accent-color": true,
            "rounded-md": true,
            "py-1": true,
            "px-3": true,
            "dark:bg-gray-700": !this.disabled,
            "dark:bg-gray-900": this.disabled,
            "bg-neutral-100": this.disabled,
            "cursor-not-allowed" : this.disabled,
          },
        },
        invoiceRightAlign: {
          label: "text-base text-stone-900 dark:text-slate-100 font-bold mb-1",
          input: {
            'w-full' : true,
            'text-right' : true,
            'text-base' : true,
            'outline-none' : true,
            'border-2': true,
            'border-gray-200' : true,
            'dark:border-transparent' : true,
            'dark:hover:border-slate-500' : true,
            'dark:focus-visible:border-slate-500' : true,
            'focus-visible:border-accent-color' : true,
            'rounded-md' : true,
            'py-1' : true,
            'px-3' : true,
            "dark:bg-gray-700": !this.disabled,
            "dark:bg-gray-900": this.disabled,
            "bg-neutral-100": this.disabled,
            "cursor-not-allowed" : this.disabled,
          },
        },
        error: {
          label:
            "text-base text-stone-900 dark:text-slate-100 font-bold mb-1 block",
          input:{
            'w-full' : true,
            'text-base' : true,
            'outline-none' : true,
            'border-2' : true,
            'border-red-400' : true,
            'dark:border-transparent' : true,
            'dark:hover:border-slate-500' : true,
            'dark:focus-visible:border-slate-500' : true,
            'focus-visible:border-accent-color' : true,
            'rounded-md' : true,
            'py-1.5' : true,
            'px-3' : true,
            "dark:bg-gray-700": !this.disabled,
            "dark:bg-gray-900": this.disabled,
            "bg-neutral-100": this.disabled,
            "cursor-not-allowed" : this.disabled,
            },
        },
        }
    },
    componentName() {
      return "TextInput";
    },
    cssLabel: function () {
      if (
        this.predefinedStyle !== undefined &&
        this.predefinedStyles[this.predefinedStyle] !== undefined
      ) {
        return this.predefinedStyles[this.predefinedStyle]["label"];
      }
      return this.predefinedStyles["default"]["label"];
    },
    cssInput: function () {
      if (
        this.predefinedStyle !== undefined &&
        this.predefinedStyles[this.predefinedStyle] !== undefined
      ) {
        return this.predefinedStyles[this.predefinedStyle]["input"];
      }

      if (this.additionalCss !== undefined) {
        this.predefinedStyles["default"]["input"] += " " + this.additionalCss;
      }

      return this.predefinedStyles["default"]["input"];
    },
  },
  mounted() {
    if (this.setref != undefined) {
      this.emitter.on("text-input:" + this.setref + ":focus", (event) => {
        this.$refs[this.setref].focus();
      });
    }
  },
};
</script>
